import { FourOFour } from "~/components/shared";

export function loader() {
  return new Response("Not Found", {
    status: 404,
  });
}

export default function PageNotFound() {
  return <FourOFour whatsNotFound="page" />;
}
